// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__1Rhml","glare":"Skeleton_glare__kDtnv"};